import { QuotaTypeEnum } from './enums'

/**额度变动类型 */
export const QUOTA_TYPE_ENUM_MAP = new Map([
  [QuotaTypeEnum.QuotaAllocation, '额度发放'],
  [QuotaTypeEnum.QuotaRecycle, '额度回收'],
  [QuotaTypeEnum.QuotaConsumption, '额度消费'],
  [QuotaTypeEnum.QuotaRollback, '额度回退'],
])
